import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Faqs from "./faqs";
import "../css/bootstrap.min.css";
import "../js/menu.js";
import useAuth from "src/hooks/useAuth";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import { useParams } from "react-router";
import axiosInstance from "src/utils/axios";

import sbLogo from "../images/samualLogo.png";
import LanguagePopover from "src/layouts/shared/header/language-popover";




const Index = () => {
  const { uname } = useParams();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [openRegister, setOpenRegister] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);
  const [emailMessage, setEmailMessage] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State for menu visibility
  const { user, logout, isAdmin } = useAuth();
  const isLoggedIn = !user;
  const { t } = useTranslation();

  const handleClickOpenRegister = () => {
    setOpenRegister(true);
    setOpenLogin(false);
  };

  const handleCloseRegister = () => {
    setOpenRegister(false);
  };

  const handleClickOpenLogin = () => {
    setOpenLogin(true);
    setOpenRegister(false);
  };

  const handleCloseLogin = () => {
    setOpenLogin(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle menu state
  };

  useEffect(() => {
    if (uname) {
      handleClickOpenRegister();
    }
  }, [uname]);

  const fetchBrandSettings = async () => {
    try {
      const { data, status } = await axiosInstance("api/brand-details");
      if (status === 200) {
        const { logo, side_bar_logo, favicon } = data.data;
        if (logo) {
          localStorage.setItem("logo", logo);
          localStorage.setItem("side_bar_logo", side_bar_logo);
          localStorage.setItem("favicon", favicon);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchBrandSettings();
  }, []);

  return (
    <>
          <Helmet>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="keywords" content="" />
        <meta name="author" content="" />
        <meta name="robots" content="" />
        <meta name="description" content="" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link rel="stylesheet" href="assets/css/bootstrap.min.css" />
        <link rel="stylesheet" href="assets/css/style.css" />
        <script src="js/jquery-1.12.4.min.js"></script>
        <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js"></script>
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;1,100;1,200;1,300;1,400&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://cdn.jsdelivr.net/npm/remixicon@4.2.0/fonts/remixicon.min.css"
          rel="stylesheet"
        />
      </Helmet>
      <body
        style={{
          fontFamily: "'Montserrat', sans-serif",
          backgroundColor: "#0a1d3b",
        }}
      >
        <div class="bodyBox">
          
          <div className="container" id="navbar">
            <header className="page-header">
              <div className="page-header__top">
                <div className="page-header__toggle" onClick={toggleMenu}>
                  ☰
                </div>
              </div>
              <nav className="page-header__bottom">
                <ul
                  id="navigation"
                  className={`navigation ${isMenuOpen ? "navigation--visible" : ""}`}
                >
                  <li className="navigation__item">
                    <a href="/">{t("global.home")}</a>
                  </li>
                  <li className="navigation__item">
                    <a href="/">{t("global.about")}</a>
                  </li>
                  <li className="navigation__item">
                    <a href="/faq">FAQ</a>
                  </li>
                </ul>
              </nav>
              <div className="page-header__logo">
                <img src={sbLogo} alt="Sambusiness Logo" />
              </div>
              <ul className="loginBox">
                <LanguagePopover />
                <li className="navigation__item">
                  {isLoggedIn ? (
                    <a
                      className="loginButton"
                      href={
                        isAdmin
                          ? "/admin/dashboard/business"
                          : "/user/dashboard"
                      }
                    >
                      {t("global.logIn")}
                    </a>
                  ) : (
                    <a className="loginButton" href="/auth/login">
                      {t("global.Dashboard")}
                    </a>
                  )}
                </li>
              </ul>
            </header>
          </div>
        
        </div>
        <div style={{ backgroundColor: "#0a1d3b" }}>
          <section class="faqSection">
            <div className="container">
              <Typography color={"white"} variant="h5">
                {t("global.Frequently")}
              </Typography>
              <Faqs />
            </div>
          </section>
        </div>
      </body>
    </>
  );
};

export default Index;
